import { MinimalAuthRawReturn, MinimalMercureAuthRawReturn } from '@/modules/Auth/apiTypes/base'
import { APIRoute } from '@/modules/utils'

export type Body = {
  refresh_token: string
}

export type Response = MinimalAuthRawReturn

export type MercureBody = {}

export type MercureResponse = MinimalMercureAuthRawReturn

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/token/refresh',
}
export const MercureRoute: APIRoute = {
  method: 'GET',
  path: '/v2/mercure/token/refresh',
}
